import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Gallery } from "@/components/landing/Gallery";
import { Showreel } from "@/components/landing/Showreel";
import { About } from "@/components/landing/About";
import { Services } from "@/components/landing/Services";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { Preloader } from "@/components/landing/Preloader";
import { useSettings } from "@/lib/useSettings";

export default function Landing() {
  const lenisRef = useRef(null);
  const [intro, setIntro] = useState(() => !sessionStorage.getItem("aaf_intro"));
  const settings = useSettings();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (intro && lenisRef.current) lenisRef.current.stop();
    if (!intro && lenisRef.current) lenisRef.current.start();
  }, [intro]);

  const finishIntro = () => {
    sessionStorage.setItem("aaf_intro", "1");
    setIntro(false);
  };

  const scrollTo = (id) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(id, { offset: id === "#top" ? 0 : -70, duration: 1.4 });
    }
  };

  return (
    <div data-testid="landing-page" className="bg-ink text-ivory min-h-screen">
      <div className="grain-overlay" aria-hidden />
      <AnimatePresence>
        {intro && <Preloader onComplete={finishIntro} />}
      </AnimatePresence>
      <Navbar onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} active={!intro} />
        <Marquee />
        <Gallery />
        <Showreel />
        <About />
        <Services />
        <Contact settings={settings} />
      </main>
      <Footer onNavigate={scrollTo} settings={settings} />
    </div>
  );
}
